/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayslipTheme } from './PlayslipTheme';
import {
    PlayslipThemeFromJSON,
    PlayslipThemeFromJSONTyped,
    PlayslipThemeToJSON,
} from './PlayslipTheme';

/**
 * Every theme a customer has defined, for the back office.
 * @export
 * @interface GetPlayslipThemesResponse
 */
export interface GetPlayslipThemesResponse {
    /**
     * 
     * @type {Array<PlayslipTheme>}
     * @memberof GetPlayslipThemesResponse
     */
    items: Array<PlayslipTheme>;
}

/**
 * Check if a given object implements the GetPlayslipThemesResponse interface.
 */
export function instanceOfGetPlayslipThemesResponse(value: object): value is GetPlayslipThemesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetPlayslipThemesResponseFromJSON(json: any): GetPlayslipThemesResponse {
    return GetPlayslipThemesResponseFromJSONTyped(json, false);
}

export function GetPlayslipThemesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayslipThemesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PlayslipThemeFromJSON)),
    };
}

export function GetPlayslipThemesResponseToJSON(value?: GetPlayslipThemesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map(PlayslipThemeToJSON)),
    };
}

